<template>
    <div id="footer" class="footer-component footer-container">
        <div class="top">
            <div class="social-media">
                <router-link :to="{ name: 'contactUs' }"><img src="@/assets/images/footer/business.png" alt="business"></router-link>
                <a href="https://www.linkedin.com/company/pegatron/posts/?feedView=all"><img src="@/assets/images/footer/linkin.png" alt="linkin"></a>
                <a href="https://www.instagram.com/pegatron_go/"><img src="@/assets/images/footer/ig.png" alt="instagram"></a>
                <a href="https://www.youtube.com/@pegatroncorp.6158/videos"><img src="@/assets/images/footer/youtube.png" alt="youtube"></a>            </div>
            <div :class="footerClass[index]" v-for="(rootItem, index) in footer" :key="index">
                <ul>
                    <div class="title">
                        {{ rootItem.languageFamilyList.find(l => l.lang == $i18n.locale).content }}
                    </div>
                    <template v-for="(secondItem, index) in rootItem.subMenu" :key="index">
                         <router-link v-if="!secondItem.link?.includes('news')"
                            :to="clickFooter(rootItem, secondItem)">
                            <li>
                                {{ secondItem.languageFamilyList.find(l => l.lang == $i18n.locale).content }}
                            </li>
                        </router-link>
                    </template>
                </ul>
            </div>
        </div>
        <div class="bottom">
            <div class="copyright">© PEGATRON Corporation. All rights reserved</div>
            <div class="function">
                <router-link :to="{ name: 'contactUs' }" class="footer-border-right">{{ $t('footer.contactUs') }}</router-link>
                <router-link :to="{ name : 'privacy'}" class="footer-border-right">{{ $t('footer.privacyAndCookiesPolicy') }}</router-link>
                <a href="#" class="footer-padding-right" @click.prevent="$store.dispatch('cookieConsent/openSettingsFromFooter')">{{ $t('footer.cookieSettings') }}</a>
            </div>
        </div>
    </div>
</template>

<style scoped>
.footer-container .top a {
    color: var(--third-color);
    text-decoration: none;
}
.footer-container .bottom a {
    text-decoration: none;
}
.footer-container .top a:hover,
.footer-container .top .router-link-active,
.footer-container .top .router-link-exact-active {
    text-decoration: none;
}

@media (min-width: 1200px) {
    .footer-container .top,
    .footer-container .bottom{
        max-width: 1200px;
    };
}
/* 新增 class 定義 */
.footer-border-right {
    border-right: 1px solid #3a3a3a;
}

.footer-padding-right {
    padding-right: 0 !important;
}
</style>

<script>
import store from "@/store"
import menuMixin from '@/mixins/menuMixin';
export default {
    name: 'FooterComponent',
    mixins: [menuMixin],
    data() {
        return {
            footer: store.state.menu,
            footerClass: ['about', 'product-service', 'investor', 'csr', 'recruit']
        }
    },
}
</script>

<style src="@/assets/css/footer_computer.css" scoped></style>